export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-3xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>

          <div className="relative z-10 flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">随时随地，畅享漫画</h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6">
              非常爱漫画全面适配移动端阅读，下拉式阅读体验在手机上同样流畅丝滑。无需下载APP，浏览器打开即看，节省手机空间。添加到桌面即可像原生应用一样使用，追更看漫画从未如此简单。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50/20 backdrop-blur-sm rounded-full text-background-50 text-sm font-medium cursor-pointer">
                <i className="ri-smartphone-line"></i>
                <span>手机端体验</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50/20 backdrop-blur-sm rounded-full text-background-50 text-sm font-medium cursor-pointer">
                <i className="ri-add-box-line"></i>
                <span>添加到桌面</span>
              </div>
            </div>
          </div>

          <div className="relative z-10 w-48 h-80 md:w-56 md:h-96 flex-shrink-0">
            <div className="w-full h-full rounded-2xl border-4 border-background-50/30 overflow-hidden bg-background-50/10 backdrop-blur-sm flex items-center justify-center">
              <div className="text-center text-background-50/60">
                <i className="ri-smartphone-line text-5xl mb-2 block"></i>
                <span className="text-xs">移动端预览</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}